import { render, staticRenderFns } from "./UsersSection.vue?vue&type=template&id=409f2020&scoped=true&"
import script from "./UsersSection.vue?vue&type=script&lang=js&"
export * from "./UsersSection.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/adminSection.css?vue&type=style&index=0&id=409f2020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409f2020",
  null
  
)

export default component.exports